<template>
    <app-page-content>
        <app-title text="Tareas Resueltas" />
        <app-resolved-tasks-filters @filter="onFilter" />
        <app-resolved-tasks-list
            :data="data"
            @change-page="changePage"
            @sort="onSort"
        />
    </app-page-content>
</template>
<script>
import ResolvedTasksFilters from './ResolvedTasksFilters/ResolvedTasksFilters.vue';
import ResolvedTasksList from './ResolvedTasksList/ResolvedTasksList.vue';
import tasksRepository from '../../../../repositories/tasks.repository';

export default {
    components: {
        appResolvedTasksFilters: ResolvedTasksFilters,
        appResolvedTasksList: ResolvedTasksList
    },
    data(){
        return {
            data: {},
            filters: null,
            page: 1,
            sort: {
                sortBy: 'name',
                sortDir: 'asc'
            },
        }
    },
    methods: {
        loadTasks(){
            const tr = {...tasksRepository};
            const filters = {...this.filters, status: 'approved', sortBy: this.sort.sortBy, sortDir: this.sort.sortDir };
            tr.getTasksByAssigned(this.user.id, filters, this.page)
            .then(data => this.data = data)
            .catch(error => toastr.error('Ocurrió un error al cargar las tareas'));
        },
        onFilter(filters){
            this.filters = filters;
            this.loadTasks();
        },
        changePage(page){
            this.page = page;
            this.loadTasks();
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadTasks();
        },  
        initialize(){
            this.loadTasks();
        },
        deleteComment(payload) {
            const task = this.data.data.find(task => task.id === payload.taskId);

            if(!task) return;

            task.detailsShowing = true;

            task.notes = task.notes.filter(note => note.id !== payload.noteId);
        }
    },
    created(){
        this.initialize();
        this.$bus.$on('task-note.delete', this.deleteComment);

    }
}
</script>